<span *ngIf="reopened" class="tag reopened">
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true">
    <path d="M3 12a9 9 0 0 1 15.5-6.3L21 3" /><path d="M21 3v6h-6" />
  </svg>
  {{ '@issueTagReopened' | translate }}
</span>

<span *ngIf="dvirOrigin" class="tag dvir-origin">{{ '@issueTagDvir' | translate }}</span>
